import type { Handlers } from './types';

/* 
    Returns the label wrapped around the input if there is one
    as the label text is part of the interactive area
*/
export const getHoverProxy = (element: HTMLInputElement): HTMLElement =>
	element.parentElement?.tagName === 'LABEL' ? element.parentElement : element;

export const addListeners = (
	handlers: Handlers,
	refElement: HTMLInputElement,
	hoverElement: HTMLElement,
) => {
	refElement.addEventListener('change', handlers.load);
	refElement.addEventListener('focusin', handlers.preload);
	refElement.addEventListener('focusout', handlers.cancelPreload);
	hoverElement.addEventListener('mouseenter', handlers.preload);
	hoverElement.addEventListener('mouseleave', handlers.cancelPreload);
};

export const removeListeners = (
	handlers: Handlers,
	refElement: HTMLInputElement,
	hoverElement: HTMLElement,
) => {
	refElement.removeEventListener('change', handlers.load);
	refElement.removeEventListener('focusin', handlers.preload);
	refElement.removeEventListener('focusout', handlers.cancelPreload);
	hoverElement.removeEventListener('mouseenter', handlers.preload);
	hoverElement.removeEventListener('mouseleave', handlers.cancelPreload);
};
